import SalaryDataTable from "@/components/Salary/SalaryDataTable.vue";
import SalaryMonthSelector from "@/components/Salary/SalaryMonthSelector.vue";
import { getOwnedTeams } from "@/services/metaDataService";
import { getSalariedEmployees, getSalaryDetails, putMonthtlySalaries, } from "@/services/salaryService";
import dateFormatter from "@/utility/dateFormatter";
import moment from "moment";
import Vue from "vue";
import AdditionalSalaryModal from "@/components/Salary/AdditionalSalaryModal/AdditionalSalaryModal.vue";
import VariableSalaryModal from "@/components/Salary/VariableSalaryModal/VariableSalaryModal.vue";
import VariablePaymentType from "@/enums/VariablePaymentType";
import { mapGetters } from "vuex";
export default Vue.extend({
    components: {
        SalaryDataTable,
        SalaryMonthSelector,
        VariableSalaryModal,
        AdditionalSalaryModal,
    },
    data() {
        return {
            filter: "",
            salaryRows: [],
            ownedTeams: [],
            variableSalaryDialog: false,
            additionalSalaryDialog: false,
            salaryRowDetails: undefined,
            loading: false,
            selectedDate: dateFormatter.newDateString(),
            salaryRow: undefined,
        };
    },
    async mounted() {
        this.loadOwnedTeams();
        this.loadSalaryData();
    },
    computed: {
        ...mapGetters({ currentUser: "getLoggedInUser" }),
        ownedTeamNames() {
            const isTeamOwner = (team) => {
                return (team.directorId === this.currentUser.userId ||
                    team.teamManagerId === this.currentUser.userId);
            };
            return this.ownedTeams
                .filter(isTeamOwner)
                .map((team) => team.name)
                .join(", ");
        },
        selectedMonth() {
            return dateFormatter.fromDateString(this.$data.selectedDate).getMonth();
        },
        selectedYear() {
            return dateFormatter.fromDateString(this.$data.selectedDate).getYear();
        },
    },
    filters: {
        toReadableMonth(date) {
            return dateFormatter.fromDateString(date).format.toMonthYearText;
        },
    },
    methods: {
        async loadSalaryData() {
            this.loading = true;
            this.salaryRows = await getSalariedEmployees(this.selectedYear, this.selectedMonth);
            this.loading = false;
        },
        async loadOwnedTeams() {
            this.ownedTeams = await getOwnedTeams(this.selectedYear, this.selectedMonth);
        },
        async onCreateFromModal(salaryRow) {
            await this.onRowCreate(salaryRow);
        },
        async onRowCreate(salaryRow) {
            await this.onRowUpdate(salaryRow);
            if (this.salaryRow === undefined) {
                return;
            }
            const currentlySelectedUserRow = this.salaryRow.userId;
            this.salaryRow = this.salaryRows.find((employee) => employee.userId === currentlySelectedUserRow);
            if (this.salaryRow === undefined) {
                return;
            }
            try {
                this.salaryRowDetails = await getSalaryDetails(this.salaryRow.paymentId, this.salaryRow.paymentType);
            }
            catch (error) {
                console.error("Unable to fetch detailed information");
                this.salaryRowDetails = undefined;
            }
        },
        async onRowUpdate(salaryRow) {
            let payoutDate = salaryRow.expectedPaymentDate;
            if (!payoutDate) {
                payoutDate = moment()
                    .year(this.selectedYear)
                    .month(this.selectedMonth - 1)
                    .date(25)
                    .toISOString();
            }
            try {
                await putMonthtlySalaries(this.selectedYear, this.selectedMonth, salaryRow.userId, payoutDate);
            }
            catch (error) {
                window.errorHandler.logError(error, "admin/SalaryView.vue - onRowUpdate");
            }
            await this.loadSalaryData();
        },
        async onVariableSalaryClicked(salaryRow) {
            this.salaryRow = this.salaryRows.find((salary) => salary.userId === salaryRow.userId);
            if (this.salaryRow.paymentType === VariablePaymentType.None) {
                this.variableSalaryDialog = true;
                return;
            }
            try {
                this.salaryRowDetails = await getSalaryDetails(this.salaryRow.paymentId, this.salaryRow.paymentType);
            }
            catch (error) {
                console.error("Unable to fetch detailed information", error);
                this.salaryRowDetails = undefined;
            }
            this.variableSalaryDialog = true;
        },
        async onAdditionalSalaryClicked(salaryRow) {
            this.additionalSalaryDialog = true;
            this.salaryRow = this.salaryRows.find((salary) => salary.userId === salaryRow.userId);
        },
        async downloadSalaryAsCSV() {
            try {
                const response = await this.$store.dispatch("downloadSalaryCSV", { year: this.selectedYear, month: this.selectedMonth });
                const downloadLink = document.createElement("a");
                downloadLink.href = response.headers.location;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
            catch (err) {
                window.errorHandler.logError(err, "SalaryView.vue -> downloadSalaryAsCSV");
            }
        },
        onPreviousMonth() {
            this.selectedDate = dateFormatter
                .fromDateString(this.selectedDate)
                .subtract.months(1);
            this.loadSalaryData();
        },
        onToday() {
            this.selectedDate = dateFormatter.newDateString();
            this.loadSalaryData();
        },
        onNextMonth() {
            this.selectedDate = dateFormatter
                .fromDateString(this.selectedDate)
                .add.months(1);
            this.loadSalaryData();
        },
    },
});
